var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 647,
    height: 1746,
    viewBox: "0 0 647 1746",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2642_521)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 449.173,
    ry: 640.081,
    transform: "matrix(0.706513 -0.7077 -0.779284 -0.626671 -305.452 872.86)",
    fill: "#FF3D00",
    fillOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2642_521)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 304.196,
    ry: 457.659,
    transform: "matrix(0.706513 -0.7077 -0.779284 -0.626671 -305.722 873.283)",
    fill: "#FF9900",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2642_521",
    x: -1257.72,
    y: 0.0336914,
    width: 1904.54,
    height: 1745.65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 180.5,
    result: "effect1_foregroundBlur_2642_521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2642_521",
    x: -1083.18,
    y: 153.653,
    width: 1554.92,
    height: 1439.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 180.5,
    result: "effect1_foregroundBlur_2642_521"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg-1.76b7a402e37a6106fa4de1c8e7911096.svg";
export { ForwardRef as ReactComponent };